import * as React from 'react'
import { memo } from 'react'
const SvgFacebook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 8.569 16"
  >
    <path d="m8.008 9 .444-2.9H5.674V4.225a1.448 1.448 0 0 1 1.633-1.564H8.57V.2A15.4 15.4 0 0 0 6.328 0a3.535 3.535 0 0 0-3.784 3.9v2.2H0V9h2.544v7h3.13V9Z" />
  </svg>
)
const Memo = memo(SvgFacebook)
export default Memo
